"use client";

import React from "react";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function LeadershipIntroduction() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: subRef,
    isVisible: isSubVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: sepRef,
    isVisible: isSepVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="leadership-introduction" className="relative w-full overflow-hidden bg-[#FDFAF3] pt-36 pb-0 md:pt-44 text-[#1C1917]">
      {/* Top-left glow */}
      <div className="pointer-events-none absolute left-0 top-0 h-[620px] w-[620px] -translate-x-1/3 -translate-y-1/3 rounded-full bg-[#E7D8B8]/55 blur-[100px]" />

      <div className="relative z-10 mx-auto flex w-full max-w-[1500px] flex-col items-start px-6 md:px-10 lg:px-12">
        <div className="mb-6 flex items-center gap-4">
          <span className="h-px w-9 bg-[#B45309]" />
          <span className="font-mono text-xs font-bold uppercase tracking-[0.3em] text-[#B45309]">
            Leadership
          </span>
        </div>

        <h2 ref={headerRef} className={`max-w-6xl font-serif text-5xl font-semibold leading-[1.05] tracking-tight text-[#1C1917] transition-all duration-1000 ease-out md:text-7xl ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          Founding <span className="text-[#B45309]">Partners</span>
        </h2>

        <p ref={subRef} className={`mt-8 mb-16 max-w-4xl text-lg leading-relaxed text-[#1C1917]/65 transition-all delay-200 duration-1000 ease-out md:text-xl ${isSubVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          55+ years of combined experience in institutional fund operations,
          data center infrastructure, M&amp;A execution, and cross-border
          capital formation — purpose-built to deploy AI-ready infrastructure at
          scale.
        </p>

        <div ref={sepRef} className={`w-full origin-left transition-all delay-400 duration-1000 ease-out ${isSepVisible ? "opacity-100 scale-x-100" : "opacity-0 scale-x-0"}`}>
          <Separator className="h-px w-full bg-[#D8C29A]" />
        </div>
      </div>
    </section>;
}